import type { Messages } from "@prop/i18n";
import type en from "../en/security";

export default {
  title: "Seguridad",
  lead: "Quién puede iniciar sesión en tu cuenta y cómo: el segundo factor, los códigos de recuperación, los dispositivos y la contraseña.",
  mfa: {
    title: "Verificación en dos pasos",
    on: "Activada",
    off: "Desactivada",
    requiredStaff: "Obligatoria para el personal: el área de administración sigue cerrada hasta que añadas un segundo factor.",
    recommended: "Recomendada: protege tu cuenta y tus payouts aunque se filtre tu contraseña.",
    addTotp: "Añadir app de autenticación",
    addKey: "Añadir llave de seguridad o passkey",
    keyLabel: "Nombre de la llave",
    keyLabelDefault: "Llave de seguridad",
    remove: "Quitar",
    lastUsed: "Último uso: {when}",
    never: "nunca usada",
    totpScan: "Escanea este código con Google Authenticator, 1Password, Authy o una app similar, o escribe la clave a mano.",
    totpSecret: "Clave",
    totpConfirm: "Escribe el código de 6 dígitos de la app",
    factorTotp: "App de autenticación",
    factorWebauthn: "Llave de seguridad",
  },
  recovery: {
    title: "Códigos de recuperación",
    left: { one: "{count} código sin usar", other: "{count} códigos sin usar" },
    regenerate: "Generar códigos nuevos",
    show: "Guarda estos códigos en un lugar seguro. Cada uno sirve una vez; solo se muestran ahora.",
    copy: "Copiar",
    copied: "Copiado",
    done: "Ya los guardé",
  },
  stepUp: {
    title: "Confirma que eres tú",
    hint: "Los cambios sensibles requieren una confirmación reciente (válida 5 minutos).",
    confirm: "Confirmar",
    cancel: "Cancelar",
    activeUntil: "Confirmado hasta {time}",
    telegramHint: "Confirma en Telegram: toca el botón y aprueba en nuestro bot.",
  },
  sessions: {
    title: "Dispositivos con sesión iniciada",
    current: "Este dispositivo",
    revoke: "Cerrar sesión",
    revokeAll: "Cerrar sesión en todos",
    revokeAllConfirm: "¿Cerrar sesión en todos los dispositivos, incluido este?",
    since: "Desde {when}",
    seen: "Activo: {when}",
    unknownDevice: "Navegador desconocido",
    showAll: "Mostrar los {n}",
    showLess: "Mostrar menos",
  },
  password: {
    title: "Contraseña",
    current: "Contraseña actual",
    new: "Nueva contraseña",
    change: "Cambiar contraseña",
    changed: "Contraseña cambiada. Se cerró la sesión en los demás dispositivos.",
  },
  profile: {
    title: "Perfil",
    save: "Guardar",
    saved: "Guardado",
    telegram: "Telegram",
    telegramLinked: "Vinculado",
  },
} satisfies Messages<typeof en>;
